/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import Box, { BoxProps } from '../../../box'

/* -----------------------------------------------------------------------------
 * WebRadioButtonElement
 * -------------------------------------------------------------------------- */

export type RadioButtonElementProps = Pick<
  React.ComponentProps<'input'>,
  'disabled'
> &
  BoxProps & {}

const WebRadioButtonElement = (props: RadioButtonElementProps) => {
  return (
    <Box {...props}>
      <input
        type='radio'
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          background: 'transparent',
          border: 'none',
          boxShadow: 'none',
          opacity: 0,
          padding: 0,
          margin: 0,
          flex: '1 1 auto',
          width: '100%',
          height: '100%'
        }}
      />
    </Box>
  )
}

export default WebRadioButtonElement
